import { withProps } from 'recompose';

import { CAPITAL_ONE_ID, MASTERCARD_ID, VISA_ID } from 'bundles/teams-v2/constants';
import { BANNER_MOCKS } from 'bundles/teams-v2/constants/bannerMocks';
import type { BannerMock } from 'bundles/teams-v2/types/sharedTypes';

type PropsFromCaller = {
  promotionId?: string;
};

export type PropsFromMockEnhancer = {
  promotionBanners?: BannerMock;
};

const getPromoMockBanners = ({ promotionId }: PropsFromCaller) => {
  let promotionBanners: BannerMock | undefined;

  if (promotionId === CAPITAL_ONE_ID) {
    promotionBanners = BANNER_MOCKS.CAPITAL_ONE;
  }

  // Mastercard `Mastercard Priceless Specials:unitedpoints10:62547:nYTCtPatEeqrqBIivh7_bQ`
  if (promotionId === MASTERCARD_ID) {
    promotionBanners = BANNER_MOCKS.MASTERCARD;
  }

  // Visa `Visa Commercial Cards:visacommercialcards10:62548`
  if (promotionId === VISA_ID) {
    promotionBanners = BANNER_MOCKS.VISA;
  }

  return promotionBanners;
};

export const hasPromoMockBanners = (props: PropsFromCaller) => {
  return !!getPromoMockBanners(props);
};

// This requires a map between the 3 promotions we want to launch with and official branded assets.
export const withPromoMockBanners = withProps<PropsFromMockEnhancer, PropsFromCaller>((props) => {
  return {
    promotionBanners: getPromoMockBanners(props),
  };
});
